import { render, staticRenderFns } from "./vue-include.vue?vue&type=template&id=71efe6b4&"
import script from "./vue-include.vue?vue&type=script&lang=js&"
export * from "./vue-include.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports